import React from "react";
import Tabs from "../tabs";

interface tabItem {
    id: string;
    name: string;
    isActive?: boolean;
    content: React.ReactNode;
}

interface Props {
    actionTabItems: tabItem[];
}

function Action(props: Props) {
    const { actionTabItems } = props;
    return (
        <div className="cmp-action">
            <Tabs tabItems={actionTabItems} />
        </div>
    );
}

export default Action;
